import React from 'react';
import { Box, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

// Activeer met REACT_APP_MAINTENANCE_BANNER=1 in de build-env (zie .github/workflows/azure-frontend.yml).
// Optioneel: REACT_APP_MAINTENANCE_MESSAGE overschrijft de standaardtekst.
// Niet dismissible — tijdens onderhoud willen we de waarschuwing zichtbaar houden voor alle gebruikers.
const MaintenanceBanner = () => {
  if (process.env.REACT_APP_MAINTENANCE_BANNER !== '1') return null;

  const message =
    process.env.REACT_APP_MAINTENANCE_MESSAGE ||
    'Onderhoud gepland — tijdelijk kunnen sync naar Gripp/Airtable en sommige functies haperen.';

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 2000,
        bgcolor: '#fef3c7',
        color: '#78350f',
        borderBottom: '2px solid #f59e0b',
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <WarningAmberIcon sx={{ fontSize: 18 }} />
      <Typography variant="body2" sx={{ fontWeight: 600, color: 'inherit' }}>
        {message}
      </Typography>
    </Box>
  );
};

export default MaintenanceBanner;
